export default {
	data() {
		return {
			WidthDefaultMobile: 765,
			viewportWidth: 0
		};
	},
	methods: {
		handleResize() {
			this.viewportWidth =
				window.innerWidth || document.documentElement.clientWidth;
		},
		isMobileSize() {
			if (this.viewportWidth < this.WidthDefaultMobile) {
				return false;
			} else {
				return true;
			}
		}
	},
	computed: {
		vertical() {
			return this.isMobileSize();
		},
		isMobile () {
			return !this.isMobileSize();
		}
	},
	mounted() {
        this.handleResize();
		window.addEventListener("resize", this.handleResize);
	}
};
